module.exports = __webpack_public_path__ + "media/images/menu/atlas-74c25ae12e76869c9ef46a349d98680a.jpg";